import * as React from 'react';
import styles from './printedBomBulletList.module.css';
// PrintedBomBulletList is wrapped in a fragment intentionally because the DynamicPage component
// with which it is used slices it's immediate children into sub-arrays to be rendered
// across multiple pages when necessary. Returning this list wrapped in a single element
// would prevent this from working correctly.
export const PrintedBomBulletList = ({ list, }) => Boolean(list && list.length) && (React.createElement(React.Fragment, null, list.map((text, index) => (React.createElement("p", { key: `bullet_point_item_${text}_${index}`, className: styles.Item },
    React.createElement("span", { className: styles.BulletPoint }, "\u2022"),
    text)))));
